import {SUCCESS} from "../../../../constants/action-postfix";
import {SUMM_GRADUATES_HEO_REQUEST} from "../summGraduatesHEOReducer";


const initialState = null;

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${SUMM_GRADUATES_HEO_REQUEST}${SUCCESS}`:
            return action.payload;
        default:
            return state;
    }
};